import React from "react";

const MenuPage = () => {
  return <div>MenuPage</div>;
};

export default MenuPage;
